import { createContext, useContext } from 'react';
import { IOrganization } from '../modules/unsw-fhir/Organization';

export interface IOrganizationContext {
  organization?: IOrganization;
  error?: string;
  setOrganization: (organization: IOrganization) => void;
  getOrganizationName: () => string;
  loading?: boolean;
}

export const initialOrganizationContext: IOrganizationContext = {
  setOrganization: () => {},
  getOrganizationName: () => 'Unknown',
};

export const OrganizationContext = createContext<IOrganizationContext>(
  initialOrganizationContext,
);

export const useOrganization = () => {
  const organization = useContext(OrganizationContext);

  return organization;
};
